export default __webpack_public_path__ + "static/rfq-fabrics-e574e1385f1d161f0a45f75218fbdf87.png";